/**
 * Version courante des Conditions Générales d'Utilisation et de la Politique
 * de Confidentialité.
 *
 * 📌 RÈGLE À SUIVRE :
 * ----------------
 * Bump cette constante à CHAQUE modification substantielle du texte des
 * CGU ou de la politique de confidentialité. La valeur est persistée dans :
 *   - `profiles.terms_version` (colonne dénormalisée, dernière version acceptée)
 *   - `user_consents.terms_version` (audit-log append-only, historique complet)
 *
 * Un écart entre `profiles.terms_version` et la valeur courante doit déclencher
 * un prompt de re-consentement côté UI.
 *
 * Format recommandé : "cgu-<X.Y>-privacy-<X.Y>" où X.Y suit semver-like
 * (majeur = changement de fond nécessitant re-consentement explicite,
 *  mineur = clarification ou correction rédactionnelle).
 *
 * Historique :
 *   - cgu-1.0-privacy-1.0 (2026-04-16) : version initiale avec case
 *     d'acceptation obligatoire à l'inscription.
 */
export const CURRENT_TERMS_VERSION = "cgu-1.0-privacy-1.0";
